import { movies } from "@/mocks/movies";
import MovieCard from "@/components/feature/MovieCard";
import { useState } from "react";
import { categories } from "@/mocks/movies";

export default function LatestSection() {
  const [activeTab, setActiveTab] = useState("all");
  const filtered = activeTab === "all" ? movies : movies.filter((m) => m.category === activeTab);
  const sorted = [...filtered].sort((a, b) => b.updateDate.localeCompare(a.updateDate));
  const displayTabs = categories.slice(0, 6);

  return (
    <section className="px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
          <div>
            <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">每日同步更新，第一时间追新片</p>
          </div>
        </div>

        <div className="flex items-center gap-1 mb-6 overflow-x-auto pb-1 flex-wrap">
          {displayTabs.map((tab) => (
            <button
              key={tab.slug}
              onClick={() => setActiveTab(tab.slug)}
              className={`px-4 py-1.5 text-sm rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                activeTab === tab.slug
                  ? "bg-primary-500 text-background-50 font-medium"
                  : "bg-background-100 text-foreground-600 hover:text-primary-500"
              }`}
            >
              {tab.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
          {sorted.map((movie) => (
            <MovieCard
              key={movie.id}
              id={movie.id}
              title={movie.title}
              slug={movie.slug}
              category={movie.category}
              year={movie.year}
              rating={movie.rating}
              poster={movie.poster}
              tags={movie.tags}
            />
          ))}
        </div>
      </div>
    </section>
  );
}